import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=93d013e0&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('93d013e0')) {
      api.createRecord('93d013e0', component.options)
    } else {
      api.reload('93d013e0', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=93d013e0&", function () {
      api.rerender('93d013e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-20f4MZMZR9awa/JS/comp/pricelist.vue"
export default component.exports